import { Link } from 'react-router-dom';
import EmptyState from '../../../components/ui/EmptyState';
import Badge from '../../../components/ui/Badge';

function daysUntil(dateStr) {
  return Math.ceil((new Date(dateStr) - new Date()) / (1000 * 60 * 60 * 24));
}

export default function ExpiryWatchlistView({ data }) {
  if (data.items.length === 0) return <EmptyState title={`Nothing expiring within ${data.days} days.`} />;

  return (
    <div>
      <p className="mb-4 text-sm text-gray-600">
        Expiring within <strong>{data.days}</strong> days
      </p>
      <table className="min-w-full divide-y divide-gray-100 text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
            <th className="py-2">Candidate</th>
            <th className="py-2">Item</th>
            <th className="py-2">Expiry date</th>
            <th className="py-2">Days left</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.items.map((item, i) => {
            const remaining = daysUntil(item.expiry_date);
            return (
              <tr key={i}>
                <td className="py-2">
                  <Link to={`/candidates/${item.candidate_id}`} className="text-primary hover:underline">
                    {item.reference_no}
                  </Link>{' '}
                  <span className="text-gray-500">{item.full_name}</span>
                </td>
                <td className="py-2 text-gray-700">{item.item}</td>
                <td className="py-2 text-gray-700">{new Date(item.expiry_date).toLocaleDateString()}</td>
                <td className="py-2">
                  <Badge tone={remaining < 0 ? 'red' : remaining <= 14 ? 'amber' : 'gray'}>
                    {remaining < 0 ? 'Expired' : `${remaining}d`}
                  </Badge>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
